module.exports = __webpack_public_path__ + "images/psp/SelfStorage/shutterstock_2575870815-scaled.jpg";